import { useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import CommercialLgCard from "../../components/cards/CommercialLgCard";
import CommercialSmCard from "../../components/cards/CommercialSmCard";
import ItemsCard2 from "../../components/cards/ItemsCard2";
import Header from "../../components/globals/Header";
import SearchBar from "../../components/inputs/SearchBar";
import AddCommercialModal from "../../components/modals/AddCommercialModal";
import CustomizableSpecialDropdown from "../../components/specials/CustomizableSpecialDropdown";
import { useCommercialHooks } from "../../hooks/useCommercialHooks";
import { useTranslation } from "../../languages";
const Commercials = () => {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const user = useSelector((s) => s?.user ?? {});
  const { t } = useTranslation();
  console.log("user data is>>>", user);
  const {
    //all local states
    commercial_All_data_redux,
    popularCommercialData_redux,
    allNearPlaces_Redux,
    allUserCommercialData_redux
  } = useCommercialHooks();
  console.log("all Commercial Redux datssa", commercial_All_data_redux);
  return (
    <div>
      <Container fluid>
        <Header title={t("commercials")} />
        <div className="row">
          <div className="col d-flex justify-content-end">
            <CustomizableSpecialDropdown
              toggler={
                <Link
                  style={{ borderRadius: "34px" }}
                  className="btn text-white inner-shadow-white border-none bg-primary-blue d-flex align-items-center gap-1"
                >
                  <IoIosAddCircleOutline size={20} />
                  {t("addNew")}
                </Link>
              }
            >
              <Link
                to={"/commercials/addComercials"}
                className="btn py-3 d-flex align-items-center gap-1 justify-content-start f-5 bg-transparent border-none"
              >
                <p className="m-0">{t("addNewCommercial")}</p>
              </Link>
              <div className="horizontal-line"></div>
            </CustomizableSpecialDropdown>
          </div>
        </div>
        <SearchBar />
        <div className="mt-2rem">
          <ItemsCard2
            firstItems={allNearPlaces_Redux}
            secondItems={commercial_All_data_redux}
            ComponentForFirstItems={CommercialLgCard}
            ComponetForSecondItems={CommercialSmCard}
            thirdItems={popularCommercialData_redux}
            fourthItems={allUserCommercialData_redux}
            // canAddNew={user?.roles?.[0] === "contributor"}
            onAddClick={() => setAddModalOpen((prev) => !prev)}
            user={user}
          />
        </div>
      </Container>
      <AddCommercialModal isOpen={addModalOpen} setisOpen={setAddModalOpen} />
    </div>
  );
};
export default Commercials;
